export const THEME_STORAGE_KEY = "brokkerspot-admin-theme";

export const THEME_MODES = [
  { id: "light", label: "Light" },
  { id: "dark", label: "Dark" },
];

export function isValidThemeMode(mode) {
  return THEME_MODES.some((t) => t.id === mode);
}

export function getStoredThemeMode() {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    return isValidThemeMode(stored) ? stored : "light";
  } catch {
    return "light";
  }
}
